import React, { useState, useEffect, useCallback } from 'react';
import AdminBankRequests from './AdminBankRequests';

// Урезанная панель "Банк", доступная из бокового меню.
// Показывает только заявки на вывод и пополнение — без Счетов, Инвойсов и Дешифратора.
// Использует тот же AdminBankRequests, что и полная Админ-панель (Банк → Вывод/Пополнения),
// поэтому логика и данные полностью совпадают.
function BankPanel({ tgId, adminNickname, canAct }) {
  const [subTab, setSubTab] = useState('withdrawals'); // withdrawals, deposits
  // Количество активных (PENDING) заявок по каждой подвкладке — тот же
  // источник данных, что и бейдж у пункта "Банк" в боковом меню, только
  // с разбивкой по типу заявки.
  const [counts, setCounts] = useState({ withdrawals: 0, deposits: 0 });

  const fetchCounts = useCallback(async () => {
    try {
      const res = await fetch('/api/bank/admin-pending-count');
      const data = await res.json();
      setCounts({ withdrawals: data.withdrawals || 0, deposits: data.deposits || 0 });
    } catch (err) {
      console.error('Ошибка загрузки количества заявок банка', err);
    }
  }, []);

  useEffect(() => {
    fetchCounts();
    const interval = setInterval(fetchCounts, 2000);
    return () => clearInterval(interval);
  }, [fetchCounts]);

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Банк</h2>

      <div className="sub-tabs">
        <button className={subTab === 'withdrawals' ? 'active' : ''} onClick={() => setSubTab('withdrawals')}>
          Вывод
          {counts.withdrawals > 0 && <span className="sub-tab-badge">{counts.withdrawals > 99 ? '99+' : counts.withdrawals}</span>}
        </button>
        <button className={subTab === 'deposits' ? 'active' : ''} onClick={() => setSubTab('deposits')}>
          Пополнения
          {counts.deposits > 0 && <span className="sub-tab-badge">{counts.deposits > 99 ? '99+' : counts.deposits}</span>}
        </button>
      </div>

      <AdminBankRequests tgId={tgId} adminNickname={adminNickname} activeSubTab={subTab} canAct={canAct} />
    </div>
  );
}

export default BankPanel;
